import type { LoggedInDto } from "../types";
import { useState } from "#imports";

/**
 * Authentication data held in Nuxt state
 */
export const useAuthState = () => useState<LoggedInDto | null>( "auth", () => null );
